module.exports = __webpack_public_path__ + "img/thumbnail_AsianWaterMonitor_j_albino.3d1ce505.png";